import { useMutation, useQuery } from 'react-query';
import { HrScoringService } from '@api/HrScoringService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListHrScoring = (
  [
    page_no,
    searchText,
    selectedParameter,
    selectedMainTab,
    selectedMinScore,
    selectedMaxScore,
    selectedEmployee
  ],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    [
      'hr-scoring-list',
      page_no,
      searchText,
      selectedParameter,
      selectedMainTab,
      selectedMinScore,
      selectedMaxScore,
      selectedEmployee
    ],
    HrScoringService.listHrScoring,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Create
const useAddHrScoring = (onSuccess, onError = onDefaultError) => {
  return useMutation(HrScoringService.addHrScoring, {
    onSuccess,
    onError
  });
};
// Employee List
const useGetHrScoringEmployeeList = ({ hr_id }, onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['hr-scoring-employee-list', hr_id], // ✅ unique key per hr_id
    () => HrScoringService.getHrScoringEmployeeList({ hr_id }), // ✅ pass hr_id
    { onSuccess, onError} // only fetch if hr_id is set
  );
};
// Parameter List
const useGetParameterList = (onSuccess, onError = onDefaultError) => {
  return useQuery('hr-scoring-parameter-list', HrScoringService.getParameterList, {
    onSuccess,
    onError
  });
};
// Hr List
const useGetAllHr = (onSuccess, onError = onDefaultError) => {
  return useQuery('hr-scoring-hr-list', HrScoringService.getHrScoringHrList, {
    onSuccess,
    onError
  });
};
// Details
const useViewHrScoring = (
  { selectedEditId, selectedUserHrScoreDetailId },
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['hr-scoring-view', selectedEditId, selectedUserHrScoreDetailId],  // ✅ both IDs in cache key
    () => HrScoringService.viewHrScoring({ selectedEditId, selectedUserHrScoreDetailId }),
    {
      onSuccess,
      onError,
      enabled: !!selectedEditId,       // ✅ only call when both exist
    }
  );
};
// Update
const useUpdateHrScoring = (onSuccess, onError = onDefaultError) => {
  return useMutation(HrScoringService.updateHrScoring, {
    onSuccess,
    onError
  });
};
// Remove
const useDeleteHrScoring = (onSuccess, onError = onDefaultError) => {
  return useMutation(HrScoringService.deleteHrScoring, {
    onSuccess,
    onError
  });
};

// Details
const useShowHrScoring = (selectedViewId, onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['hr-scoring-show', selectedViewId],   // ✅ include id in key
    () => HrScoringService.showHrScoring(selectedViewId),
    {
      onSuccess,
      onError,
      enabled: !!selectedViewId
    }
  );
};
// Team Access 
const useGetTeamAccess = (onSuccess, onError = onDefaultError) => {
  return useQuery('hr-scoring-team-access', HrScoringService.getTeamAccessORNot, {
    onSuccess,
    onError
  });
};
export {
  useListHrScoring,
  useAddHrScoring,
  useGetHrScoringEmployeeList,
  useGetParameterList,
  useViewHrScoring,
  useUpdateHrScoring,
  useDeleteHrScoring,
  useShowHrScoring,
  useGetAllHr,
  useGetTeamAccess
};
